import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { observable } from 'mobx';
import { ProductRepository } from '../repositories/ProductRepository';
import { IPowerReviewsProduct, IProduct, IPowerReviews } from '../interfaces/IRating';
import { query, serviceQueries } from 'elc-service-bus';

export class PowerReviewsInitializedUseCase {
    @observable public productRepository: ProductRepository;
    @observable public productId: string;

    constructor(productId: string) {
        this.productId = productId;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    private async waitForObject(object: IPowerReviews, callback: () => void) {
        while (Object.keys(object).length === 0 && object.constructor === Object) {
            // tslint:disable-next-line: no-string-based-set-timeout
            await new Promise(res => setTimeout(res, 100));
        }
        callback();
    }

    private async renderReviews(powerReviewsProduct: IPowerReviewsProduct) {
        // @ts-ignore
        await this.waitForObject(window.POWERREVIEWS, () => {
            // @ts-ignore
            window.POWERREVIEWS.display.render(powerReviewsProduct);
            const reviewSection = document.querySelector('.spp-reviews-wrapper');
            if (reviewSection) {
                reviewSection.classList.remove('hidden');
            }
        });
    }

    public execute = async () => {
        // tslint:disable-next-line: await-promise
        const products = await query(serviceQueries.GET_REVIEW_PRODUCT, this.productId);

        const powerReviewsProduct: IPowerReviewsProduct = this.productRepository.getPowerReviewsProduct(
            <IProduct[]>products
        );

        const reviewContent = <HTMLElement>document.querySelector('.js-spp-reviews');
        if (reviewContent) {
            reviewContent.id = powerReviewsProduct.reviewDisplayId;
        }

        await this.renderReviews(powerReviewsProduct);
    };
}
